module.exports = __webpack_public_path__ + "static/img/hall-thruster.ae91d0b.jpg";